module.exports = __webpack_public_path__ + "static/media/dalmia_logo.290b7daa.jpg";